export default "__VITE_ASSET__5d1b8fe4__"